import { render, staticRenderFns } from "./pay-success.vue?vue&type=template&id=bc412190&scoped=true&"
import script from "./pay-success.vue?vue&type=script&lang=js&"
export * from "./pay-success.vue?vue&type=script&lang=js&"
import style0 from "./pay-success.vue?vue&type=style&index=0&id=bc412190&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc412190",
  null
  
)

export default component.exports